import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const FadeUp = ({ children, delay = 0, className = "", as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      initial={{ opacity: 0, y: 32 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.75, delay, ease: EASE }}
      className={className}
    >
      {children}
    </Tag>
  );
};

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden ${className}`}>
    <motion.span
      className="block"
      initial={{ y: "112%" }}
      animate={{ y: 0 }}
      transition={{ duration: 0.95, delay, ease: EASE }}
    >
      {children}
    </motion.span>
  </span>
);

export const Eyebrow = ({ children, suit, className = "" }) => (
  <p
    className={`text-[11px] sm:text-xs tracking-[0.3em] uppercase text-brass font-medium ${className}`}
  >
    {suit && (
      <span aria-hidden="true" className="mr-2 text-brass">
        {suit}
      </span>
    )}
    {children}
  </p>
);

const MARQUEE_ITEMS = [
  ["♠", "Play Freely"],
  ["♥", "Play Hard"],
  ["♦", "Play Safe"],
  ["♣", "Play Again"],
  ["·", "Sydney"],
  ["·", "18+ only"],
  ["·", "Private events"],
  ["·", "Discretion respected"],
];

export const Marquee = () => {
  const row = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      aria-hidden="true"
      className="relative overflow-hidden border-y border-brass/15 bg-charcoal/60 py-4 select-none"
    >
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10">
            {row.map(([mark, text], i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center gap-3 font-serif text-lg italic text-ivory/60"
              >
                <span className="text-sm not-italic text-brass/70">{mark}</span>
                {text}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
